import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Header from '../header/header';
import Footer from '../footer/footer';
import TopButton from '../fixed_btns/fixed_btns';

import styles from './layout.module.css';

const Layout = ({ preFetch }) => {
  const location = useLocation();

  useEffect(() => {
    let { pathname } = location;
    !pathname.includes('solution/') &&
      !pathname.includes('hardware/') &&
      window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <Header preFetch={preFetch} />

      <div className={styles.contents}>
        <Outlet />
      </div>
      <Footer />
      <TopButton />
    </>
  );
};

export default Layout;
